// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3x6i4","option":"styles_option__120mv","active":"styles_active__2syfa"};